import { Card, Tabs, TabsProps } from 'antd';
import styled from 'styled-components';

import BasicReport from './illegal-handle-basic';
import NamespaceReport from './illegal-handle-namespace';
import { IllegalHandleProvider } from './illegal-handle.context';

/**
 * 违法处置统计
 */
const IllegalHandlePage: React.FC = () => {
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: '总报表',
      children: (
        <IllegalHandleProvider>
          <BasicReport />
        </IllegalHandleProvider>
      ),
    },
    {
      key: '2',
      label: '按部门',
      children: (
        <IllegalHandleProvider>
          <NamespaceReport />
        </IllegalHandleProvider>
      ),
    },
  ];
  return (
    <>
      <Container
        bodyStyle={{
          paddingBottom: 0,
          paddingTop: 0,
        }}
        title="违法处置统计"
      >
        <Tabs defaultActiveKey="1" destroyInactiveTabPane items={items} />
      </Container>
    </>
  );
};

const Container = styled(Card)`
  border: none !important;
  min-width: 1200px;
  .ant-card-head {
    border: 0 !important;
    .ant-card-extra {
      padding: 8px 0;
    }
  }
  .ant-typography {
    color: rgba(0, 0, 0, 0.65);
  }
`;

export default IllegalHandlePage;
